<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><a id="page_ii"></a><em class="italic">In loving memory of my late wife and soulmate</em></p>
<p class="ded"><em class="italic">Evelyn Jean Tremain</em></p>
<p class="ded"><em class="italic">(1952–2022)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Memory.vue?36b0a32a